import { css } from 'styled-components';

import { colors } from '@/constants/theme';

export const RangeStyles = css`
  input[type='range'] {
    cursor: pointer;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    -webkit-appearance: none;
    background-color: #a1a4a9;
    height: 4px;
  }

  input[type='range']::-webkit-slider-thumb {
    z-index: 2;
    -webkit-appearance: none;
    width: 14px;
    height: 14px;
    border-radius: 10px;
    background-color: ${colors.main};
    cursor: grab;
  }
`;
